import { render, staticRenderFns } from "./ConsultaUsuarios.vue?vue&type=template&id=b612db4e&scoped=true&"
import script from "./ConsultaUsuarios.vue?vue&type=script&lang=js&"
export * from "./ConsultaUsuarios.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaUsuarios.vue?vue&type=style&index=0&id=b612db4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b612db4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
